"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*!
  Copyright (c) 2019 DynAgility LLC. All rights reserved.
  Licensed under the MIT License.
*/
var react_1 = require("react");
var redux_react_hook_1 = require("redux-react-hook");
var immutable_1 = require("immutable");
var actions_1 = require("./actions");
var auth_1 = require("./auth");
var DETAULT_TIMEOUT = 60000; // One Minute Timeout
function useAPI(url, substitutions, method, key) {
    if (substitutions === void 0) { substitutions = {}; }
    if (method === void 0) { method = 'GET'; }
    if (key === void 0) { key = url; }
    var auth = react_1.useContext(auth_1.AuthContext);
    var dispatch = redux_react_hook_1.useDispatch();
    var substitutedKey = actions_1.substituteParams(key, substitutions);
    var client = react_1.useMemo(function () { return new actions_1.APIClient(url, key, method, substitutions, auth); }, [url, key, method, substitutions]);
    var doRequest = function (body, force, timeout) {
        if (force === void 0) { force = false; }
        if (timeout === void 0) { timeout = DETAULT_TIMEOUT; }
        return dispatch(client.request(force, timeout, body));
    };
    var data = redux_react_hook_1.useMappedState(react_1.useCallback(function (state) { return state.api.get(client.getKey() + ":" + client.getMethod(), immutable_1.Map({})).toJS(); }, [substitutedKey, method]));
    var resetStateAPI = function () { return dispatch(actions_1.resetState(client.getUrl(), method)); };
    return [data, doRequest, resetStateAPI];
}
exports.useAPI = useAPI;
var reducer_1 = require("./reducer");
exports.ApiReducer = reducer_1.default;
var auth_2 = require("./auth");
exports.AuthContext = auth_2.AuthContext;
exports.JWTAuthStrategy = auth_2.JWTAuthStrategy;
exports.AuthReducer = auth_2.AuthReducer;
exports.mapUser = auth_2.mapUser;
